import { render, staticRenderFns } from "./DialogAddProjetoLei.vue?vue&type=template&id=31d23178&scoped=true&"
import script from "./DialogAddProjetoLei.vue?vue&type=script&lang=js&"
export * from "./DialogAddProjetoLei.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddProjetoLei.vue?vue&type=style&index=0&id=31d23178&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d23178",
  null
  
)

export default component.exports